import { useState, useEffect } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { showDetailsBox } from "../../../services/leitnerApi";
import {
  checkResponseData,
  customToastify,
  LoadingSvg,
} from "../../utils/utils";
import { Link } from "react-router-dom";
import { Typography, Button, Divider } from "@mui/material";

export default function BoxContents(props) {
  const { boxCards, boxInfo, handleStartStudy, handleStudyCards } = props;
  const [info, setInfo] = useState({
    name: false,
    fromLang: false,
    toLang: false,
    description: false,
  });

  useEffect(() => {
    if (boxInfo["_id"]) setInfo(boxInfo);
  }, [boxInfo]);

  return (
    <>
      {boxInfo == "loading" ? (
        <Box sx={{ textAlign: "center", my: 1.5 }}>
          <Typography>لطفا صبر کنید</Typography>
          <LoadingSvg />
        </Box>
      ) : (
        <>
          <Box sx={{ textAlign: "center", my: 1.5 }}>
            <Button
              variant="contained"
              color="info"
              onClick={() => {
                handleStartStudy(true);
                handleStudyCards({ boxInfo, boxCards });
              }}
            >
              شروع یادگیری
            </Button>
          </Box>
          <Divider
            sx={{
              textAlign: "center",
              color: (theme) =>
                theme.palette.reverse.status == "dark" ? "goldenrod" : "blue",
            }}
          >
            {"نام لایتنر"}
          </Divider>
          <Box sx={{ textAlign: "center", mb: 1 }}>
            <Typography>{info["name"] || <LoadingSvg />}</Typography>
          </Box>
          <Divider
            sx={{
              textAlign: "center",
              color: (theme) =>
                theme.palette.reverse.status == "dark" ? "goldenrod" : "blue",
            }}
          >
            {"زبان اصلی"}
          </Divider>
          <Box sx={{ textAlign: "center", mb: 1 }}>
            <Typography>{info["fromLang"] || <LoadingSvg />}</Typography>
          </Box>
          <Divider
            sx={{
              textAlign: "center",
              color: (theme) =>
                theme.palette.reverse.status == "dark" ? "goldenrod" : "blue",
            }}
          >
            {"زبان ترجمه"}
          </Divider>
          <Box sx={{ textAlign: "center", mb: 1 }}>
            <Typography>{info["toLang"] || <LoadingSvg />}</Typography>
          </Box>
          <Divider
            sx={{
              textAlign: "center",
              color: (theme) =>
                theme.palette.reverse.status == "dark" ? "goldenrod" : "blue",
            }}
          >
            {"تعداد لغات آماده مرور"}
          </Divider>
          <Box sx={{ textAlign: "center", mb: 1 }}>
            <Typography>{boxCards.length}</Typography>
          </Box>
          <Divider
            sx={{
              textAlign: "center",
              color: (theme) =>
                theme.palette.reverse.status == "dark" ? "goldenrod" : "blue",
            }}
          >
            {"توضیحات"}
          </Divider>
          <Box sx={{ textAlign: "center", mb: 1 }}>
            <Typography>{info["name"] && !info["description"] ? "----" : info["description"] || <LoadingSvg />}</Typography>
          </Box>
        </>
      )}
    </>
  );
}
